import { Platform, Text, View } from 'react-native';
import { useQuery } from '@tanstack/react-query';
import apis from '@api/api';
import { useEffect, useState } from 'react';
import GenerateSchemaForm from '@hooks/generateSchemaForm';
import LottieView from '@utils/lottieAnimation';
import styles from '@stylesheet';
import React, { forwardRef, useMemo, useCallback } from 'react';
import BottomSheet, {
  BottomSheetModal,
} from '@gorhom/bottom-sheet';
import { Title } from '@constants/Themed';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';
import CustomDatePicker from './customDatePicker';

const ReportDates = forwardRef<BottomSheet>((props: any, ref) => {
  const theme = themeSelector();

  const snapPoints = useMemo(() => ['22%', '50%'], []);

const selectionPress = () => {
  console.log('pressed')
}

const valueChange = () =>{
  console.log('value changed')
}

  const handleSheetChanges = useCallback((index: number) => {
  }, []);

  if (Platform.OS != 'web') {
    return (
      <BottomSheet handleIndicatorStyle={{ backgroundColor: theme ? 'black' : 'white' }} containerStyle={{overflow:'visible'}} backgroundStyle={{ backgroundColor: theme ? 'white' : 'black' }} ref={ref} snapPoints={snapPoints} onChange={handleSheetChanges} style={[styles.bottomSheet, {padding: 0,overflow:'visible'}]} >
        <CustomDatePicker onSectionPress={selectionPress} onValueChange={valueChange} />
      </BottomSheet>
    )
  } else return (
    <>
    </>
  )
})
export default ReportDates